import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import './styles.css';
import './brand.css';
import './landing.css';
import { AppShell } from './components/AppShell.js';
import { ComparePage } from './pages/ComparePage.js';
import { EmbedPage } from './pages/EmbedPage.js';
import { Landing } from './pages/Landing.js';
import { MapPage } from './pages/MapPage.js';
import { SignIn } from './pages/SignIn.js';
import { WatchlistPage } from './pages/WatchlistPage.js';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Landing /> },
      { path: 'map/:chain/:address', element: <MapPage /> },
      { path: 'compare', element: <ComparePage /> },
      { path: 'watchlist', element: <WatchlistPage /> },
    ],
  },
  { path: '/signin', element: <SignIn /> },
  { path: '/embed/:chain/:address', element: <EmbedPage /> },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
